/**
 * @generated SignedSource<<2fc8b0b7463b6fe9f9d4fe26dcea4a22>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateAssetPayload",
            "kind": "LinkedField",
            "name": "updateAsset",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "validateProficiency",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AssetProficienciesPanel_updateAssetMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AssetProficienciesPanel_updateAssetMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "a6714522cf7fcf5959b94c43972fd433",
            "id": null,
            "metadata": {},
            "name": "AssetProficienciesPanel_updateAssetMutation",
            "operationKind": "mutation",
            "text": "mutation AssetProficienciesPanel_updateAssetMutation(\n  $model: UpdateAssetRequestInput!\n) {\n  updateAsset(model: $model) {\n    asset {\n      id\n      validateProficiency\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "bc05a069030d1b6d032deb8de03f6c80";
export default node;
